import { render } from "./payment.vue?vue&type=template&id=52ddf3c8&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"

import "./payment.vue?vue&type=style&index=0&id=52ddf3c8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ddf3c8"]])

export default __exports__